import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  v1ModalTitle: {
    defaultMessage: 'Delete API Key',
    id: '4d/UmT',
    description: 'Title for the confirm modal when deleting V1 API Key',
  },
  v2ModalTitle: {
    defaultMessage: 'Delete API Key',
    id: 'PItmMx',
    description: 'Title for the confirm modal when deleting V2 API Keys',
  },
  modalCancelButton: {
    defaultMessage: 'Cancel',
    id: '0GT0SI',
    description: 'Cancel button label',
  },
  v1ModalBodyTitle: {
    defaultMessage: 'Are you sure you want to delete this key?',
    id: 'MbhImC',
    description: 'Title for the confirm modal content for deleting V1 API Key',
  },
  v2ModalBodyTitle: {
    defaultMessage: 'Are you sure you want to delete this key?',
    id: '7Nd4iS',
    description: 'Title for the confirm modal content for deleting V2 API Key',
  },
  v1ModalBodyContent: {
    defaultMessage:
      'Deleting this key will invalidate your previous key and <b>cannot be undone</b>. Any platforms that use this key will need to be updated if you generate a new key.',
    id: 'ctzA8q',
    description: 'Content for the confirm modal content when deleting V1 API Key',
  },
  v2ModalBodyContent: {
    defaultMessage:
      'Deleting this key will invalidate your previous key and <b>cannot be undone</b>. Any platforms that use this key will need to be updated if you generate a new key.',
    id: 'rSN62K',
    description: 'Content for the confirm modal content when deleting V2 API Key',
  },
  v1ActionMessage: {
    defaultMessage: 'Delete Key',
    id: 'gIk5gY',
    description: 'Action button label when removing v1 api key',
  },
  v2ActionMessage: {
    defaultMessage: 'Delete Key',
    id: 'XDple4',
    description: 'Action button label when removing v2 api key',
  },
});
